import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Portfolio = () => {
  const [portfolio, setPortfolio] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const response = await axios.get(`${API}/portfolio`);
        setPortfolio(response.data);
      } catch (error) {
        console.error('Error fetching portfolio:', error);
        // Fallback portfolio data
        setPortfolio({
          categories: [
            {
              name: "Weddings",
              images: [
                "https://images.unsplash.com/photo-1519741497674-611481863552?w=800",
                "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800",
                "https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=800",
                "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800"
              ]
            },
            {
              name: "Civil Weddings",
              images: [
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/uxnev559_zxzx%20%283%29.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/t34tiydt_zxzx%20%284%29.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/rcerghe6_zxzx%20%285%29.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/gvmg2tqr_zxzx%20%281%29.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/dvw9uu1q_zxzx%20%282%29.jpg"
              ]
            },
            {
              name: "Birthdays",
              images: [
                "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800",
                "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?w=800",
                "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=800",
                "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=800"
              ]
            },
            {
              name: "21st Birthdays",
              images: [
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/8qqoif5t_Mysticson2-221.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/vrxnmxn0_Mysticson2-18.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/cf0kax7z_Mysticson2-13.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/jvfjvo7w_Mithea%201-287.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/2nka0jez_Mysticson-14.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/qfqtahmt_Mithea%201-94.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/v77at8ap_Mithea%201-3.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/7kivohq2_Mithea-95.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/4xjojxfe_Mithea-94.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/bx2rh9e4_Mithea-91.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/askn5k06_Mithea-76.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/rdgzz16g_Mithea-71.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/yic4rfmz_Mithea-60.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/hecsn1jo_Mithea-53.jpg",
                "https://customer-assets.emergentagent.com/job_joywin-photo-deals/artifacts/bwi2y7r6_Mithea-49.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/sn6g8i45_Mithea-44.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/mrulj7my_Mithea-42.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/024ui4va_Mithea-28.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/m0s7qlg2_Mithea-17.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/q4eg2q3j_Cyble-164.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/hjt62ctj_Cyble-89.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/tj0q9xo6_Cyble-54.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/p3vjql0j_Cyble-23.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/fvocadj5_oshca%204-302.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/hookfhfj_oshca%204-107.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/j9s54ny7_oshca%204-96.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/rur1x0av_oshca%204-87.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/rggmn44g_oshca%204-61.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/yqdo2zrg_oshca%204-59.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/owd3v1pt_junius-32.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/me50i72y_junius-18.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/chfuaqam_Abigail-294.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/5co7jmzo_Abigail-62.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/xbw67w4p_Abigail-33.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/5fwml9zw_bleria%20%2874%20of%20762%29.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/kq2izu2p_bleria%20%2851%20of%20762%29.jpg"
              ]
            },
            {
              name: "Baptisms",
              images: [
                "https://images.unsplash.com/photo-1544776193-352d25ca82cd?w=800",
                "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800",
                "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800",
                "https://images.unsplash.com/photo-1504439904031-93ded9f93e4e?w=800"
              ]
            },
            {
              name: "Portraits",
              images: [
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/7ionioml_2-53.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/1yotdvfp_2-36.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/2hd3abde_2-16.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/2t67x0l7_2-7.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/z44sxqvv_2-6.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/wvtace8d_2-96.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/l45zlg5k_2-73.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/30bg1q0l_2-67.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/5aq463y3_2-59.jpg"
              ]
            },
            {
              name: "Maternity Shoots",
              images: [
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/x1dintb8_portraits-30.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/5sgiufwe_portraits-20.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/35qx4skr_portraits-2.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/igusxx3z_1-5.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/t3ogz6fj_1-3.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/6ouzbepi_portraits-84.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/usqkfg7v_portraits-82.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/dke7udbf_portraits-49.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/0ffcdw51_portraits-40.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/zt6pyrbh_portraits-33.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/4t1gdmsy_portraits-90.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/uohjs6n1_2-34.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/sjtw8vz7_2-25.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/ob88aamm_2-19.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/ml8zi33i_2-12.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/eglpdh61_2-116.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/vzp5c6hj_2-63.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/qg7js4do_2-54.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/gu98xjk5_2-44.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/yoy5pcvv_2-35.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/nm8vcwu8_2-165.jpg",
                "https://customer-assets.emergentagent.com/job_31fef50f-d042-4c3f-aeb3-c0a281a26293/artifacts/xs060d68_2-131.jpg"
              ]
            },
            {
              name: "Communion & Confirmation",
              images: [
                "https://images.unsplash.com/photo-1591392282893-ae5a80a4335c?w=800",
                "https://images.unsplash.com/flagged/photo-1578308588763-1ef11302b880?w=800",
                "https://images.unsplash.com/photo-1643270013362-609cb53ea7c4?w=800",
                "https://images.unsplash.com/photo-1771694986974-101c7703a7e2?w=800"
              ]
            }
          ]
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolio();
  }, []);

  const getAllImages = () => {
    if (!portfolio) return [];
    // Pick images round-robin from each category for a nice mix, limited to 12
    const cats = portfolio.categories.filter(c => c.images.length > 0);
    const mixed = [];
    let round = 0;
    while (mixed.length < 12 && round < 20) {
      for (const cat of cats) {
        if (round < cat.images.length && mixed.length < 12) {
          mixed.push({ name: cat.name, image: cat.images[round] });
        }
      }
      round++;
    }
    return mixed;
  };

  const getFilteredImages = () => {
    if (!portfolio) return [];
    if (activeCategory === 'all') {
      return getAllImages();
    }
    const category = portfolio.categories.find(c => c.name.toLowerCase() === activeCategory);
    return category ? category.images.map(img => ({ name: category.name, image: img })) : [];
  };

  const categories = portfolio ? ['all', ...portfolio.categories.map(c => c.name.toLowerCase())] : ['all'];

  if (loading) {
    return (
      <section className="py-24 bg-[#050505]" data-testid="portfolio-loading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-pulse">
            <div className="h-12 bg-[#1a1a1a] rounded w-64 mx-auto mb-8"></div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="aspect-square bg-[#1a1a1a] rounded-lg"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 bg-[#050505]" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[#D4AF37] tracking-[0.3em] text-sm uppercase">Our Work</span>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl text-[#EDEDED] mt-4">
            Recent <span className="gold-gradient-text">Portfolio</span>
          </h2>
          <p className="text-[#A1A1AA] mt-4 max-w-2xl mx-auto">
            Browse through our collection of cherished moments captured with love and precision.
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12" data-testid="portfolio-filters">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeCategory === category
                  ? 'gold-gradient-btn'
                  : 'bg-[#1a1a1a] text-[#A1A1AA] hover:text-[#EDEDED] border border-white/10'
              }`}
              data-testid={`filter-${category}`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <motion.div
          layout
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
          data-testid="portfolio-gallery"
        >
          {getFilteredImages().map((item, index) => (
            <motion.div
              key={`${item.name}-${index}`}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="portfolio-item aspect-square rounded-lg overflow-hidden relative group cursor-pointer"
              data-testid={`portfolio-item-${index}`}
            >
              <img
                src={item.image}
                alt={`${item.name} photography`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4">
                  <span className="text-[#D4AF37] text-sm tracking-wide uppercase">{item.name}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
